import { useState } from 'react';

const continuousPlans = [
  {
    id: 'standard',
    nameEn: 'Standard',
    name: 'スタンダードプラン',
    description: 'お手頃な料金で自由に使える',
    originalPrice: '33,000',
    price: '20,000',
    period: '円/月（税込）',
    entryFee: '10,000円（税込）',
    entryFeeNote: '※入会事務手数料無料キャンペーン中',
    features: [
      '利用可能時間: 9:00〜23:00',
      '即日入会: ○',
      '会議室予約: ○（1,500円/時）',
      '会議室へのゲスト招待: ○',
      '個人ブース予約: ○（275円/30分）',
      '法人登記・住所利用: ×',
      '最低利用期間: 1ヶ月',
    ],
    recommended: true,
    cta: '継続利用の内見予約',
    ctaLink: 'https://forms.gle/kcdbjKEZi2kF7gBB8',
  },
  {
    id: 'address',
    nameEn: 'Address',
    name: 'アドレスプラン',
    description: '登記・住所利用可能な最強プラン',
    originalPrice: '44,000',
    price: '30,000',
    period: '円/月（税込）',
    entryFee: '100,000円（税込）',
    entryFeeNote: '※入会事務手数料無料キャンペーン中',
    features: [
      '利用可能時間: 9:00〜23:00',
      '即日入会: ×（最短2週間後〜）',
      '会議室予約: ○（1,500円/時）',
      '会議室へのゲスト招待: ○',
      '個人ブース予約: ○（275円/30分）',
      '法人登記・住所利用: ○',
      '最低利用期間: 2ヶ月',
    ],
    recommended: false,
    cta: '継続利用の内見予約',
    ctaLink: 'https://forms.gle/kcdbjKEZi2kF7gBB8',
  },
  {
    id: 'dinner',
    nameEn: 'Dinner',
    name: 'ディナープラン',
    description: '仕事帰りや休日に利用する方に',
    originalPrice: '',
    price: '14,000',
    period: '円/月（税込）',
    entryFee: '10,000円（税込）',
    entryFeeNote: '※入会事務手数料無料キャンペーン中',
    features: [
      '利用可能時間: 平日17:00〜23:00 / 土日祝9:00〜23:00',
      '即日入会: ○',
      '会議室予約: ○（1,500円/時）',
      '会議室へのゲスト招待: ○',
      '個人ブース予約: ○（275円/30分）',
      '法人登記・住所利用: ×',
      '最低利用期間: 1ヶ月',
    ],
    recommended: false,
    cta: '継続利用の内見予約',
    ctaLink: 'https://forms.gle/kcdbjKEZi2kF7gBB8',
  },
];

const dropInPlans = [
  {
    id: 'flex',
    nameEn: 'Flexible',
    name: 'フレックスプラン',
    description: '30分単位で使える',
    price: '550',
    period: '円/30分（税込）',
    entryFee: '0円',
    features: [
      '利用可能時間: 全曜日 9:00〜23:00',
      '即日入会: ○',
      '会議室予約: ×',
      '個人ブース予約: ×',
      '法人登記・住所利用: ×',
    ],
    cta: '利用申込み',
    ctaLink: 'https://pass.workhub.site/spaces/drop-in/detail/KmPzAOl3HSsGdIqqdLxK',
  },
  {
    id: 'day',
    nameEn: 'Day Pass',
    name: '1Dayプラン',
    description: '3時間以上使うならこちらがお得',
    price: '3,300',
    period: '円/日（税込）',
    entryFee: '0円',
    features: [
      '利用可能時間: 全曜日 9:00〜23:00',
      '即日入会: ○',
      '会議室予約: ×',
      '個人ブース予約: ×',
      '法人登記・住所利用: ×',
    ],
    cta: '利用申込み',
    ctaLink: 'https://pass.workhub.site/spaces/drop-in/detail/6Ps8hxhmSHpBPJmzziZo',
  },
];

export default function CoworkingPricing() {
  const [activeTab, setActiveTab] = useState<'continuous' | 'dropin'>('continuous');

  return (
    <section className="py-16 sm:py-24 md:py-32 bg-[#FAF8F5]" id="pricing" aria-labelledby="pricing-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-10 sm:mb-14">
          <span className="inline-block px-3 py-1.5 bg-emerald-500/10 text-emerald-600 text-xs tracking-[0.15em] rounded-full mb-4 sm:mb-6">
            PRICING
          </span>
          <h2
            id="pricing-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-3 sm:mb-4 tracking-[0.1em]"
          >
            料金プラン
          </h2>
          <p className="text-sm sm:text-base text-black/60 font-extralight tracking-wide">
            あなたのワークスタイルに合ったプランをお選びください
          </p>

          {/* MeVER Chair 体験予約バナー */}
          <div className="mt-8 sm:mt-10 inline-flex items-center gap-4 bg-emerald-50 border border-emerald-200 rounded-xl px-6 py-4">
            <div className="w-10 h-10 flex items-center justify-center bg-emerald-500 rounded-full flex-shrink-0">
              <i className="ri-calendar-check-line text-white text-lg" aria-hidden="true"></i>
            </div>
            <div className="text-left">
              <p className="text-sm font-medium text-black tracking-wide">MeVER Chairを試してみたい方へ</p>
              <p className="text-xs text-black/50 font-extralight mt-0.5">まずは体験予約から。専門スタッフがご案内します。</p>
            </div>
            <a
              href="https://appointment.mever.design/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center px-6 py-2.5 bg-emerald-500 text-white text-sm font-light tracking-[0.1em] hover:bg-emerald-600 transition-colors whitespace-nowrap rounded-lg cursor-pointer ml-2"
            >
              体験予約
              <i className="ri-arrow-right-line ml-1.5" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        {/* Tab Switcher */}
        <div className="flex justify-center mb-10 sm:mb-14">
          <div className="inline-flex bg-gray-100 rounded-full p-1">
            <button
              onClick={() => setActiveTab('continuous')}
              className={`px-6 sm:px-8 py-2.5 sm:py-3 text-sm font-light tracking-wide rounded-full transition-all whitespace-nowrap cursor-pointer ${
                activeTab === 'continuous'
                  ? 'bg-emerald-500 text-white shadow-md'
                  : 'text-black/60 hover:text-black'
              }`}
            >
              継続利用（サブスク）
            </button>
            <button
              onClick={() => setActiveTab('dropin')}
              className={`px-6 sm:px-8 py-2.5 sm:py-3 text-sm font-light tracking-wide rounded-full transition-all whitespace-nowrap cursor-pointer ${
                activeTab === 'dropin'
                  ? 'bg-emerald-500 text-white shadow-md'
                  : 'text-black/60 hover:text-black'
              }`}
            >
              一時利用（ドロップイン）
            </button>
          </div>
        </div>

        {/* Continuous Plans */}
        {activeTab === 'continuous' && (
          <div className="grid md:grid-cols-3 gap-6 sm:gap-8 max-w-6xl mx-auto" role="list">
            {continuousPlans.map((plan) => (
              <article
                key={plan.id}
                className={`relative bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 transition-all duration-300 hover:shadow-xl ${
                  plan.recommended
                    ? 'ring-2 ring-emerald-500 shadow-xl shadow-emerald-500/10'
                    : 'shadow-sm border border-gray-100'
                }`}
                role="listitem"
              >
                {plan.recommended && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <span className="px-4 py-1.5 bg-emerald-500 text-white text-xs font-medium tracking-[0.1em] rounded-full whitespace-nowrap">
                      おすすめ
                    </span>
                  </div>
                )}

                <div className="text-center mb-5 sm:mb-6">
                  <span className="text-xs text-black/40 font-light tracking-[0.2em] uppercase">{plan.nameEn}</span>
                  <h3 className="text-lg sm:text-xl font-light text-black mt-1 mb-1.5 tracking-wide">{plan.name}</h3>
                  <p className="text-xs text-black/60 font-extralight">{plan.description}</p>
                </div>

                <div className="text-center mb-5 sm:mb-6 pb-5 sm:pb-6 border-b border-gray-100">
                  {plan.originalPrice && (
                    <div className="text-sm text-black/40 line-through mb-1">
                      月額 {plan.originalPrice}円のところ
                    </div>
                  )}
                  <div className="flex items-baseline justify-center">
                    <span className="text-3xl sm:text-4xl font-light text-black">{plan.price}</span>
                    <span className="text-sm text-black/60 ml-1">{plan.period}</span>
                  </div>
                  <div className="mt-2 text-xs text-black/40 font-extralight">
                    入会事務手数料: {plan.entryFee}
                  </div>
                  {plan.entryFeeNote && (
                    <div className="mt-1 text-xs text-emerald-600 font-light flex items-center justify-center gap-1">
                      <i className="ri-arrow-right-s-fill text-xs" aria-hidden="true"></i>
                      {plan.entryFeeNote}
                    </div>
                  )}
                </div>

                <ul className="space-y-2.5 mb-6 sm:mb-8" aria-label={`${plan.name}の内容`}>
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-2.5">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-emerald-500 text-xs" aria-hidden="true"></i>
                      </div>
                      <span className="text-xs text-black/70 font-extralight leading-relaxed">{feature}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href={plan.ctaLink}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className={`block w-full py-3 sm:py-3.5 text-center text-sm font-light tracking-[0.1em] rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                    plan.recommended
                      ? 'bg-emerald-500 text-white hover:bg-emerald-600'
                      : 'bg-black text-white hover:bg-black/80'
                  }`}
                  aria-label={`${plan.cta}`}
                >
                  <i className="ri-calendar-line mr-1.5" aria-hidden="true"></i>
                  {plan.cta}
                </a>
              </article>
            ))}
          </div>
        )}

        {/* Drop-in Plans */}
        {activeTab === 'dropin' && (
          <div className="grid sm:grid-cols-2 gap-6 sm:gap-8 max-w-3xl mx-auto" role="list">
            {dropInPlans.map((plan) => (
              <article
                key={plan.id}
                className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300"
                role="listitem"
              >
                <div className="text-center mb-5 sm:mb-6">
                  <span className="text-xs text-black/40 font-light tracking-[0.2em] uppercase">{plan.nameEn}</span>
                  <h3 className="text-lg sm:text-xl font-light text-black mt-1 mb-1.5 tracking-wide">{plan.name}</h3>
                  <p className="text-xs text-black/60 font-extralight">{plan.description}</p>
                </div>

                <div className="text-center mb-5 sm:mb-6 pb-5 sm:pb-6 border-b border-gray-100">
                  <div className="flex items-baseline justify-center">
                    <span className="text-3xl sm:text-4xl font-light text-black">{plan.price}</span>
                    <span className="text-sm text-black/60 ml-1">{plan.period}</span>
                  </div>
                  <div className="mt-2 text-xs text-black/40 font-extralight">
                    入会事務手数料: {plan.entryFee}
                  </div>
                </div>

                <ul className="space-y-2.5 mb-6 sm:mb-8" aria-label={`${plan.name}の内容`}>
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-2.5">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-emerald-500 text-xs" aria-hidden="true"></i>
                      </div>
                      <span className="text-xs text-black/70 font-extralight leading-relaxed">{feature}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href={plan.ctaLink}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="block w-full py-3 sm:py-3.5 text-center text-sm font-light tracking-[0.1em] rounded-lg bg-emerald-500 text-white hover:bg-emerald-600 transition-colors whitespace-nowrap cursor-pointer"
                  aria-label={`${plan.cta}`}
                >
                  {plan.cta}
                  <i className="ri-external-link-line ml-1.5" aria-hidden="true"></i>
                </a>
              </article>
            ))}
          </div>
        )}

        <p className="text-center text-xs text-black/40 font-extralight mt-8 sm:mt-10 tracking-wide">
          ※ Wi-Fi・電源は全プラン共通で利用可能です。フードホールでの食事・持ち込みも全プラン可能です。
        </p>

        {/* 体験予約フローティングバナー */}
        <div className="mt-8 sm:mt-10 text-center">
          <a
            href="https://appointment.mever.design/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-black text-white text-sm font-light tracking-[0.1em] hover:bg-black/80 transition-colors whitespace-nowrap rounded-full cursor-pointer"
          >
            <i className="ri-calendar-check-line text-emerald-400" aria-hidden="true"></i>
            MeVER Chair 体験予約はこちら
            <i className="ri-arrow-right-line ml-1" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
